module.exports = __webpack_public_path__ + "static/media/surtidor-rojo.493c15c5.svg";